import React, { FunctionComponent, ReactElement, useCallback, useState } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import SmallBodyFont from '../Theme/Fonts/SmallBody'
import { TestID } from '../utils/PropTypesDefinitions'

export type CollapsingTextProps = TestID & {
    /** the text */
    text: string
    /** the clickable text when component should expand */
    expandingButtonText: string
    /** the clickable text when component should collapse */
    collapsingButtonText: string
}

const CollapsingText: FunctionComponent<CollapsingTextProps> = ({
    text,
    collapsingButtonText,
    expandingButtonText,
    testID,
}): ReactElement => {
    const [isCollapsed, setIsCollapsed] = useState(true)

    const setState = useCallback((): void => {
        setIsCollapsed(!isCollapsed)
    }, [isCollapsed])

    return (
        <Grid noExpand testID={testID}>
            <SmallBodyFont color="onyx" numberOfLines={isCollapsed ? 2 : 0} textAlign="left">
                {text}
            </SmallBodyFont>
            <Touchable onPress={setState}>
                <SmallBodyFont color="onyx" numberOfLines={1} bold textAlign="right">
                    {isCollapsed ? collapsingButtonText : expandingButtonText}
                </SmallBodyFont>
            </Touchable>
        </Grid>
    )
}

export default CollapsingText
